import { render, staticRenderFns } from "./AssignTableGroups.vue?vue&type=template&id=0a82517f&scoped=true&"
import script from "./AssignTableGroups.vue?vue&type=script&lang=ts&"
export * from "./AssignTableGroups.vue?vue&type=script&lang=ts&"
import style0 from "./AssignTableGroups.vue?vue&type=style&index=0&id=0a82517f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a82517f",
  null
  
)

export default component.exports